import { styled } from '@linaria/react'
import React, { type FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { colors } from '../styles/colors'
import { ButtonRegular } from '../ui/Button'
import { Typography } from '../ui/Typography'
import { DialogContainer } from './common.styles'

export const TaskCompletedDialog: FC<{
  onClose: () => void
}> = ({ onClose }) => {
  return (
    <DialogContainer>
      <IconContainer>
        <CheckmarkCircle>
          <Typography fontSize={28} fontWeight={700} color={colors.white}>
            ✓
          </Typography>
        </CheckmarkCircle>
      </IconContainer>

      <ContentContainer>
        <TitleContainer>
          <Typography fontSize={20} fontWeight={700} color={colors.secondary}>
            <FormattedMessage
              id="bonus.task.completed.title"
              defaultMessage="Выполнено"
            />
          </Typography>
        </TitleContainer>

        <DescriptionContainer>
          <Typography fontSize={14} fontWeight={400} color={colors.secondary}>
            <FormattedMessage
              id="bonus.task.completed.message"
              defaultMessage="Это задание уже выполнено!"
            />
          </Typography>
        </DescriptionContainer>
      </ContentContainer>

      <ButtonContainer>
        <CloseButton
          onClick={onClose}
          textColor={colors.white}
          textWeight={700}
        >
          <FormattedMessage id="common.ok" defaultMessage="OK" />
        </CloseButton>
      </ButtonContainer>
    </DialogContainer>
  )
}

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const CheckmarkCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${colors.success};
  display: flex;
  align-items: center;
  justify-content: center;
`

const ContentContainer = styled.div`
  display: grid;
  gap: 8px;
  max-width: 300px;
`

const TitleContainer = styled.div`
  text-align: center;
`

const DescriptionContainer = styled.div`
  text-align: center;
  line-height: 1.5;
`

const ButtonContainer = styled.div`
  width: 100%;
  max-width: 280px;
`

const CloseButton = styled(ButtonRegular)`
  width: 100%;
  background: ${colors.secondary};
  color: ${colors.white};
`
